import React from 'react'
import { useNavigate } from 'react-router-dom'


const LeftBlock = () => {

  const navigate = useNavigate();

  const menu = [
    {
      icon: '/images/icons/dashboard-black.svg',
      name: 'Dashboard',
      link: 'dashboard',
    },
    {
      icon: '/images/icons/dashboard-black.svg',
      name: 'Campaigns',
      link: 'campaigns',
    },
    // {
    //   icon: '/images/icons/dashboard-black.svg',
    //   name: 'Ads Report',
    //   link: 'ads-report',
    // },
    {
      icon: '/images/icons/dashboard-black.svg',
      name: 'Audiences',
      link: 'audiences',
    },
    {
      icon: '/images/icons/dashboard-black.svg',
      name: 'Account Setting',
      link: 'account-setting',
    },
    {
      icon: '/images/icons/dashboard-black.svg',
      name: 'Billing & Payment',
      link: 'billing-payment',
    },
    {
      icon: '/images/icons/dashboard-black.svg',
      name: 'Help',
      link: 'help',
    },
  ];

  return (
    <>
      <section className='left-block d-none d-lg-block overflow-y-scroll scrollbar-hidden'>
        {/* Logo */}
        <div className='d-flex align-items-end justify-content-center gap-1 my-3'>
          <img src="/images/emilo-logo.png" style={{ height: '35px' }} alt="logo" />
          <h5 className='mb-0'>Ads Engine</h5>
        </div>

        {/* Accordion */}
        <div className='rounded-4 d-flex align-items-center gap-2 shadow px-3 py-2 w-75 mx-auto my-5'>
          <img src="/images/profile.png" className='border rounded-circle' style={{ height: '45px', width: '45px' }} alt="profile" />

          <div className='me-auto'>
            <h6 className='mb-0 text-nowrap'>Siddharth Dongre</h6>
            <span className='text-secondary'>Edit Profile</span>
          </div>

          <img src="/images/icons/arrow-blue.svg" style={{ height: '25px' }} alt="arrow" />
        </div>

        {/* Menu */}
        <div className='w-75 mx-auto'>
          {
            menu.map((value, index) => (
              <div className={`${window.location.href.includes(value.link) && 'bg-primary-subtle'} cursor-pointer px-3 py-2 rounded-3 mb-3 d-flex align-items-center gap-2`} onClick={() => navigate(value.link)} key={index}>
                <img src={value.icon} style={{ height: '25px' }} alt="icon" />
                <h5 className='mb-0'>{value.name}</h5>
              </div>
            ))
          }

          {/* Logout */}
          <div className={`cursor-pointer px-3 py-2 rounded-3 mb-3 d-flex align-items-center gap-2`} onClick={() => alert('Logout')}>
            <img src='/images/icons/dashboard-black.svg' style={{ height: '25px' }} alt="icon" />
            <h5 className='mb-0'>Logout</h5>
          </div>
        </div>
      </section> 
    </>
  )
}

export default LeftBlock;